export const evaluationPanelInnerRoutePaths = {
  list: 'listagem-banca-avaliadora',
  storyResume: 'resumo-inscricao',
  adminStoryResume: 'resumo-historia',
} as const;

export const evaluationPanelPaths = {
  list: `/banca-avaliadora/${evaluationPanelInnerRoutePaths.list}/:id?`,
  storyResume: `/banca-avaliadora/${evaluationPanelInnerRoutePaths.storyResume}/:id`,
  adminStoryResume: `/banca-avaliadora/${evaluationPanelInnerRoutePaths.adminStoryResume}/:id`,
} as const;

export const EVALUATOR_QUERY_PARAM = 'avaliador';
export const BACK_TO_QUERY_PARAM = 'voltar';

const EVALUATION_PANEL_BASE_PATH = '/banca-avaliadora/';

function withQueryParams(
  path: string,
  params: Record<string, string | number | undefined>,
): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) search.set(key, String(value));
  });
  const query = search.toString();
  return query ? `${path}?${query}` : path;
}

export function isEvaluationPanelPath(path?: string | null): path is string {
  return !!path && path.startsWith(EVALUATION_PANEL_BASE_PATH);
}

export function evaluationPanelListPath(idAvaliador?: number | string): string {
  const base = `/banca-avaliadora/${evaluationPanelInnerRoutePaths.list}`;
  return idAvaliador ? `${base}/${idAvaliador}` : base;
}

export function evaluationPanelStoryResumePath(
  idHistoria: number,
  idAvaliador?: number | string,
  backTo?: string,
): string {
  const path = evaluationPanelPaths.storyResume.replace(':id', idHistoria + '');
  return withQueryParams(path, {
    [EVALUATOR_QUERY_PARAM]: idAvaliador,
    [BACK_TO_QUERY_PARAM]: backTo,
  });
}

export function evaluationPanelAdminStoryResumePath(
  idHistoria: number,
  idAvaliador?: number | string,
  backTo?: string,
): string {
  const path = evaluationPanelPaths.adminStoryResume.replace(
    ':id',
    idHistoria + '',
  );
  return withQueryParams(path, {
    [EVALUATOR_QUERY_PARAM]: idAvaliador,
    [BACK_TO_QUERY_PARAM]: backTo,
  });
}
